import 'lib-flexible/flexible.js'
import { Button,NavBar,Icon,Tabbar,Tabs,Tab, TabbarItem, Uploader, Toast, Overlay} from 'vant';
import Vue from 'vue';
Vue.use(Button)
Vue.use(NavBar)
Vue.use(Icon)
Vue.use(Tabbar)
Vue.use(Tabs)
Vue.use(Tab)
Vue.use(TabbarItem)
Vue.use(Uploader);
Vue.use(Toast);
Vue.use(Overlay);
